'use client'

import { InformationCircleIcon } from '@heroicons/react/24/outline'
import Link from 'next/link'
import { useStore } from '@/store'

const POINTS_INFO =
  'Vanishing Inc. Points are earned on eligible purchases and can be redeemed for gifts or store credit. Totals are based on product price before tax and shipping.'

export const ViPoints = ({ productOptions }: ViPointsProps) => {
  const selectedOptionId = useStore(state => state.selectedOptionId)

  const selectedOption = productOptions?.find(
    option => option?.id === selectedOptionId
  )

  // If no option is selected, show points for the first option
  const optionToDisplay = selectedOption || productOptions?.[0]

  return (
    <div>
      {optionToDisplay && (
        <span>
          Get{' '}
          <span className="font-bold text-vi-gray">
            {optionToDisplay.viPoints}
          </span>{' '}
          <Link
            href="/points/"
            prefetch={false}
            className="text-inherit underline-offset-2 hover:underline"
          >
            VI Points
          </Link>{' '}
          for this purchase.{' '}
          <Link
            href="/points/"
            prefetch={false}
            className="relative top-1 inline-flex items-center justify-center rounded leading-none text-gray-400 hover:bg-gray-100 hover:text-gray-600"
            aria-label="More about Vanishing Inc. Points"
            title={POINTS_INFO}
          >
            <InformationCircleIcon
              className="block size-[1.25em] max-h-6 max-w-6"
              aria-hidden
            />
          </Link>
        </span>
      )}
    </div>
  )
}

interface ViPointsProps {
  productOptions: {
    id: number
    viPoints: number
  }[]
}
